import React from 'react';
import RemoteIcon from 'src/components/10-atoms/icons/RemoteIcon';
import Column from 'src/components/10-atoms/layout/Column';
import Row from 'src/components/10-atoms/layout/Row';
import CustomScrollView from 'src/components/10-atoms/list-views/CustomScrollView';
import Pressable from 'src/components/10-atoms/pressables/Pressable';
import Typography from 'src/components/10-atoms/typography/Typography';
import AppAssets from 'src/constants/appAssets';
import { TypographyFontWeight, TypographyVariant, } from 'src/customizations/themes/10-parts/typography';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import useI18n from 'src/modules/translations/hooks/useI18n';
import styleUtils from 'src/utils/styles';
import { getNavEntries } from '../../primaryNav/registry';
import toSidebarItem from '../../primaryNav/toSidebarItem';
import usePrimaryNavContext from '../../primaryNav/usePrimaryNavContext';
import useActiveRouteName from '../useActiveRouteName';
import ProfileSidebarItem from './ProfileSidebarItem';
import SidebarItem from './SidebarItem';
import stylesGenerator from './styles';
const DesktopSidebar = () => {
    const [{ styles, theme }] = useTheme(stylesGenerator);
    const { translate } = useI18n();
    const ctx = usePrimaryNavContext();
    const activeRouteName = useActiveRouteName();
    const mainItems = getNavEntries(ctx, 'sidebar-main').map(entry => toSidebarItem(entry, ctx));
    const footerItems = getNavEntries(ctx, 'sidebar-footer').map(entry => toSidebarItem(entry, ctx));
    const showProfile = getNavEntries(ctx, 'sidebar-profile').length > 0;
    return (React.createElement(Column, { style: styles.container, bg: theme.palette.background.subtle },
        React.createElement(Pressable, { to: { screen: 'EP_Home', params: {} }, "aria-label": "MarineSamraj home" },
            React.createElement(Row, { yAxis: "center", spacing: theme.spacing.standard.sm, style: styles.brandRow },
                React.createElement(RemoteIcon, { uri: AppAssets.logo_512_512, size: theme.iconSize.md, style: { borderRadius: '50%' } }),
                React.createElement(Typography, { flex: true, variant: TypographyVariant.BODY_TITLE, fontWeight: TypographyFontWeight.MEDIUM, numberOfLines: 1, ellipsizeMode: "tail" }, "MarineSamraj"))),
        React.createElement(CustomScrollView, { containerStyle: styleUtils.flex },
            React.createElement(Column, { flex: true, pt: theme.spacing.standard.md, spacingY: theme.spacing.standard.xxs },
                React.createElement(Column, { ph: theme.spacing.standard.md, pb: theme.spacing.standard.xs },
                    React.createElement(Typography, { variant: TypographyVariant.CAPTION, color: theme.palette.typography.secondary }, translate('Navigation'))),
                mainItems.map(item => (React.createElement(SidebarItem, { key: item.prefix, ...item, focused: !!activeRouteName?.startsWith(item.prefix) }))))),
        React.createElement(Column, { pb: theme.spacing.standard.md, spacingY: theme.spacing.standard.xxs, style: styles.footer },
            showProfile && (React.createElement(ProfileSidebarItem, { focused: !!activeRouteName?.startsWith('User_') })),
            footerItems.map(item => (React.createElement(SidebarItem, { key: item.prefix, ...item, focused: !!activeRouteName?.startsWith(item.prefix) }))))));
};
export default DesktopSidebar;
